import { queryKeys } from "../queryKeys";
import { getOrder, type Order } from "../rest/account";
import { useRequest } from ".";
import type { QueryOptions } from "./useRequest";

type UseGetOrderArgs = {
  accountID?: string;
  product?: string;
  orderId?: string;
  options?: QueryOptions<Order>;
};

export const useGetOrder = ({
  accountID,
  product,
  orderId,
  options,
}: UseGetOrderArgs) => {
  const { data, refetch, isLoading } = useRequest(
    queryKeys.orders.detail(accountID || "", orderId || "", product),
    () =>
      getOrder({
        accountID: accountID || "",
        product: product || "",
        orderID: orderId || "",
      }),
    options,
  );

  return { order: data, refetch, isLoading };
};
